import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "filter" }
const _hoisted_2 = /*#__PURE__*/_createVNode("h3", { class: "filter__title" }, "Фильтры", -1)
const _hoisted_3 = { class: "filter__block" }
const _hoisted_4 = /*#__PURE__*/_createVNode("span", { class: "hr" }, null, -1)

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_train_type_filter = _resolveComponent("train-type-filter")
  const _component_AccordionTab = _resolveComponent("AccordionTab")
  const _component_train_brand_filter = _resolveComponent("train-brand-filter")
  const _component_departure_time_filter = _resolveComponent("departure-time-filter")
  const _component_Accordion = _resolveComponent("Accordion")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode("div", _hoisted_3, [
      _createVNode(_component_Accordion, {
        multiple: true,
        activeIndex: [0]
      }, {
        default: _withCtx(() => [
          _createVNode(_component_AccordionTab, { header: "Тип поезда" }, {
            default: _withCtx(() => [
              _createVNode(_component_train_type_filter, { filterByTrainTypes: _ctx.filterByTrainTypes }, null, 8, ["filterByTrainTypes"])
            ]),
            _: 1
          }),
          _createVNode(_component_AccordionTab, { header: "Бренд поезда" }, {
            default: _withCtx(() => [
              _createVNode(_component_train_brand_filter, { filterByTrainBrands: _ctx.filterByTrainBrands }, null, 8, ["filterByTrainBrands"])
            ]),
            _: 1
          }),
          _createVNode(_component_AccordionTab, { header: "Время отправления" }, {
            default: _withCtx(() => [
              _createVNode(_component_departure_time_filter, { filterByDeparture: _ctx.filterByDeparture }, null, 8, ["filterByDeparture"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _hoisted_4,
    _createVNode("button", {
      type: "button",
      class: "submit-button",
      onClick: _cache[1] || (_cache[1] = (...args) => (_ctx.applyAllFilters(...args)))
    }, " Применить ")
  ]))
}